import { useApi } from './useApi';
import { useAppState } from './useAppState';
export function useSystemStatus() {
    const api = useApi();
    const state = useAppState();
    function fetchSystemStatus() {
        // /SystemStatus needs auth — only fetch once logged in (skips the signup flow).
        if (!state.token)
            return;
        api.GET('/SystemStatus', (result) => {
            if (!result || Object.keys(result).length === 0)
                return;
            state.systemStatus = result;
        }, true);
    }
    return { fetchSystemStatus };
}
